<template>
  <section>
    <!--工具条-->
    <el-button type="primary" @click="handleAdd">添加</el-button>
    <toolbar :buttonList="buttonList_toolBar" @callFunction="callFunction">
      <template v-slot>
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-input v-model="areaLimitName" placeholder="请输入模板名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchFun">查询</el-button>
          </el-form-item>
        </el-form>
      </template>
    </toolbar>
    <!--列表-->
    <el-card>
      <el-table
        :data="areaLimitList"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
      >
        <el-table-column type="index" width="80" align="center"></el-table-column>
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column prop="areaLimitName" label="模版名称" align="center"></el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.createTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click="handleDel(scope.row)">删除</el-button>
            <!-- <el-button
              v-for="button in buttonList_table"
              :key="button.id"
              :type="button.Func&&button.Func.toLowerCase().indexOf('del')!= -1 ? 'danger':button.Func&&button.Func.toLowerCase().indexOf('edit')!= -1?'primary':'success'"
              size="small"
              @click="callFunctionRow(button, scope.$index, scope.row)"
            >{{button.name}}</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="10"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>
    </el-card>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <Edit :editForm="editForm" :supId="ResellerId" @getSpecs="getSpecs" v-if="addFormVisible"></Edit>
    </el-dialog>
    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <Edit :editForm="editForm" :supId="ResellerId" @getSpecs="getSpecs" v-if="editFormVisible"></Edit>
    </el-dialog>
  </section>
</template>

<script>
import {
  getAreaLimitListPage,
  delAreaLimit,
  KSAXApiRequest,
  GetAllReseller
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";
import Edit from "./Edit";
export default {
  components: { Toolbar, Edit },
  data() {
    return {
      ResellerId: null,
      areaLimitName: "",
      pageIndex: 1,
      pageSize: 10,
      areaLimitList: [],
      total: 0,
      listLoading: false,

      editFormVisible: false,
      addFormVisible: false,

      addForm: {
        areaLimitName: "",
        createBy: "string",
        modifyId: 0,
        modifyBy: "string"
      },

      editForm: null,

      buttonList_table: [],
      buttonList_toolBar: []
    };
  },
  methods: {
    callFunction(item) {
      this[item.Func]();
    },
    callFunctionRow(item, index, row) {
      this[item.Func](item, index, row);
    },
    getAllReseller() {
      GetAllReseller({SkipCount: 0,MaxResultCount: 10}).then(res => {
        this.ResellerId = res.data.result.items[0].remoteKey
        this.getSpecs()
      })
    },
    searchFun() {
      this.getSpecs();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getSpecs();
    },
    //获取商品区域限购模板列表
    getSpecs() {
      let that = this;
      let para = {
        path: 'Product_AreaLimit/list',
        parms: '',
        parmsJson: {
          supId: this.ResellerId,
          PageIndex: that.pageIndex,
          PageSize: that.pageSize,
          AreaLimitName: that.areaLimitName
        }
      };
      that.addFormVisible = false;
      that.editFormVisible = false;
      that.listLoading = true;
      KSAXApiRequest(para).then(res => {
        that.total = res.data.response.dataCount;
        that.areaLimitList = res.data.response.data;
        that.listLoading = false;
      });
    },
    handleAdd() {
      this.addFormVisible = true;
      this.editForm = {};
    },
    //显示编辑界面
    handleEdit(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    //删除区域模板
    handleDel(row) {
      let that = this;
      let params = {
        path: 'Product_AreaLimit/Delete',
        parms: '',
        parmsJson: {
          id: row.id
        }
      };
      that.$confirm("此操作将永久删除该区域模板, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning"
      }).then(() => {
        KSAXApiRequest(params).then(res => {
          that.$message.success(res.data.msg);
          that.getSpecs()
        });
      });
    }
  },
  mounted() {
    this.getAllReseller();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    const toolBarButtonList = buttonList.filter(item => {
      return item.ButtonType === 10;
    });
    this.buttonList_toolBar = toolBarButtonList;
    const tableButtonList = buttonList.filter(item => {
      return item.ButtonType === 20 && item.Func!=='handleBindId';
    });
    this.buttonList_table = tableButtonList;
  }
};
</script>

<style scoped>
section{
  padding: 20px;
}
.table_box {
  width: 100%;
  padding: 20px;
}
</style>
